import BaseArrow from 'react-icons/lib/fa/angle-right'

import styled from 'styled-components'

import { white, transition, brandSecondary } from '../../../../../../utils/style-utils'

const Arrow = styled(BaseArrow)`
  display: none;
  position: absolute;
  z-index: 1;
  height: 50px;
  width: auto;
  fill: ${white};
  top: 50%;
  transform: translateY(-50%);
  ${transition('fill', 0.2)};
  margin: 15px;

  &:hover {
    fill: ${brandSecondary};
  }
`

export const ArrowPrev = styled(Arrow)`
  left: 0;
  transform: translateY(-50%) rotate(180deg);
`

export const ArrowNext = styled(Arrow)`
  right: 0;
`
